import React, {useContext, useEffect, useRef, useState} from 'react';
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import Modal from "./Modal";

const Header = () => {
    const pagesWithoutHeader = ["doc", "updates"];

    const {userStore, fileStore} = useContext(Context)

    const [menuOpen, setMenuOpen] = useState(false);
    const [modal, setModal] = useState(false);
    const menuRef = useRef(null);
    const bars = useRef(null);

    function openSide() {
        bars.current.style.display = "none";
        userStore.setOpenSide(true);
    }

    const handleOutsideClick = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
            setMenuOpen(false);
        }
    };

    async function logout() {
        await userStore.logout();
        fileStore.currentInfo = null;
    }

    async function deleteAccount() {
        await userStore.deleteAccount(userStore.user.email);
        fileStore.currentInfo = null;
    }

    useEffect(() => {
        if (userStore.openSide !== true && bars.current) bars.current.style.display = "inline-block";
        else if (bars.current) bars.current.style.display = "none";
    }, [userStore.openSide])

    useEffect(() => {
        if (menuOpen) document.addEventListener("mousedown", handleOutsideClick);
        else document.removeEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [menuOpen]);

    return (
        <header>
            {(!userStore.isAuth || pagesWithoutHeader.some(p => window.location.href.includes(p))) && <div id="logo"><a href="/" style={{whiteSpace: "nowrap"}}><span id="five-logo">5</span>core-analy<span style={{color: "red", fontFamily: "Poppins"}}>2</span>er</a></div>}
            {userStore.isAuth && !pagesWithoutHeader.some(p => window.location.href.includes(p)) && <i className="icon-bars" ref={bars} onClick={() => openSide()}></i>}
            {fileStore.currentInfo &&
                <span className="file-info" title={fileStore.currentInfo}>{fileStore.currentInfo}</span>
            }
            <div className="left-header-sec">
                {!userStore.isAuth ? (
                    <a href="/login">Войти</a>
                ) : (
                    <div className="user-section" ref={menuRef}>
                        <div
                            className="user-trigger"
                            onClick={() => {if (userStore.openSide !== true) setMenuOpen((prev) => !prev)}}
                        >
                            <i className="icon-circle-user"></i>
                            <span className="username" title={userStore.user.name}>
                                {userStore.user.name}
                            </span>
                        </div>

                        {menuOpen && (
                            <div className="user-menu">
                                <span className="username" style={{maxWidth: "1000px", paddingLeft: "10px", fontSize: "18px"}}>
                                    {userStore.user.name}
                                </span><br/>
                                <div className="user-menu-part">
                                    <a style={{color: "var(--color)", display: "flex"}} href="/doc"><span className="icon"><i className="icon-book"></i></span>Документация</a>
                                </div>
                                <div className="user-menu-part" onClick={() => userStore.setTheme()}>
                                    <span className="icon">{userStore.theme === "light" ? <i className="icon-moon"></i> : <i className="icon-sun"></i>}</span> Сменить тему
                                </div>
                                <div className="user-menu-part" onClick={() => logout()}>
                                    <span className="icon"><i className='icon-arrow-right-from'></i></span>Выйти
                                </div>
                                <div className="user-menu-part" onClick={() => setModal(true)} style={{color: "var(--red-color)"}}>
                                    <span className="icon"><i className='icon-x'></i></span>Удалить аккаунт
                                </div>
                                <div style={{content: "", padding: "5px 0"}}></div>
                                <div className="user-menu-part" style={{fontSize: "18px"}}>
                                    <a href="/updates" style={{color: "var(--color)"}}>v{process.env.REACT_APP_VERSION}</a>
                                </div>
                            </div>
                        )}
                        <Modal open={modal}>
                            <div>
                                Удалить аккаунт?<br/>
                                <button onClick={() => {setModal(false);}}>Отмена</button>
                                <button onClick={() => {setModal(false); deleteAccount()}}>Удалить</button>
                            </div>
                        </Modal>

                    </div>
                )}
            </div>
        </header>
    );
};

export default observer(Header);